const rightNavbar = {
  portugues: {
    menu: {
      hello: 'Olá',
      subscribe: 'ASSINE AGORA O BELLA',
      myAccount: 'Login',
      myCredits: 'Meus Créditos',
      myAccountLogado: 'Minha Conta',
      freetour: 'Amostra Grátis',
      modelos: 'Modelos',
      videos: 'Vídeos',
      makingof: 'Making Of',
      lives: 'Lives',
      blog: 'Blog',
      colums: 'Colunas',
      ecards: 'Ecards',
      bellacloud: 'Bella Cloud',
      menuLabel: 'MENU',
      subscribeButton: 'ASSINAR',
      renewButton: 'RENOVAR',
      upgradeButton: 'UPGRADE',
      sobre: 'Sobre o Bella',
      contactUs: 'Fale Conosco',
      logout: 'Sair',
      subscribe2: 'Assine agora',
      subscribe2Login: 'Faça um Upgrade',
      bellas: 'Bellas',
    }
  },
  ingles: {
    menu: {
      hello: 'Hello',
      subscribe: 'SUBSCRIBE TO BELLA NOW',
      myAccountLogado: 'My Account',
      myAccount: 'Login',
      myCredits: 'My Credits',
      freetour: 'Free Sample',
      modelos: 'Models',
      videos: 'Videos',
      makingof: 'Making Of',
      lives: 'Lives',
      blog: 'Blog',
      colums: 'Articles',
      ecards: 'eCards',
      bellacloud: 'Bella Cloud',
      menuLabel: 'MENU',
      subscribeButton: 'SUBSCRIBE',
      renewButton: 'RENEW',
      upgradeButton: 'UPGRADE',
      sobre: 'About us',
      contactUs: 'Contact Us',
      logout: 'Logout',
      subscribe2: 'Subscribe Now',
      subscribe2Login: 'Upgrade',
      bellas: 'Bellas',
    }
  }
}

export default rightNavbar
